<template>
    <div>
        <!--选择报名类型-->
        <div class="top-bar">
            <h2>{{ $t("apply.applyType") }}</h2>
        </div>
        <ul class="bao-type">
            <li @click="selectApply(item.feeId,item.feeFl)" v-for="(item,index) in con_fee" :key="index">
                <p :class="[info.reg_config.cfgDefFeeid == item.feeId ? 'active':'',item.feeFl=='0'?'cant_select_fee':'']">
                    <span>{{item.feeName}}</span>
                    <span>{{item.feeMoney}}{{locale=='en'?"CNY":"元"}}</span>
                </p>
            </li>
        </ul>
        <div class="top-bar">
            <h2>{{ $t("apply.applyPayType") }}</h2>
        </div>
        <div class="pay-type">
            <div class="clear" v-show="reg_config.cfgPayOnlineFl=='1' && reg_config.cfgPayOfflineFl=='1'">
                <div class="left pay-type-box">
                    <!--只有一个的情况下默认选中第一个-->
                    <p v-if="reg_config.cfgPayOnlineFl == '1'" @click="setPayType(1)" class="pay-type-item">
                        <span class="pay-type-item-icon"><i
              :class="{active: pay_type == 1 ? true: false,bounce2:pay_type == 1 ? true: false}"></i></span>
                        <span>{{ $t("pay.payOnline") }}</span>
                    </p>
                </div>
                <div class="left pay-type-box">
                    <p v-if="reg_config.cfgPayOfflineFl == '1'" @click="setPayType(2)" class="pay-type-item">
                        <span class="pay-type-item-icon"><i :class="{active: pay_type == 2 ? true: false,bounce2:pay_type == 2 ? true: false}"></i></span>
                        <span>{{ $t("pay.payOffline") }}</span>
                    </p>
                </div>
            </div>
            <div class="clear" v-show="reg_config.cfgPayOnlineFl=='0' || reg_config.cfgPayOfflineFl=='0'">
                <div class="pay-type-box" v-if="reg_config.cfgPayOfflineFl == '1'" style="margin:0 auto">
                    <p @click="setPayType(2)" class="pay-type-item">
                        <span class="pay-type-item-icon"><i :class="{active: pay_type == 2 ? true: false,bounce2:pay_type == 2 ? true: false}"></i></span>
                        <span>{{ $t("pay.payOffline") }}</span>
                    </p>
                </div>
                <div class="pay-type-box" v-if="reg_config.cfgPayOnlineFl == '1'" style="margin:0 auto">
                    <p @click="setPayType(1)" class="pay-type-item">
                        <span class="pay-type-item-icon"><i :class="{active: pay_type == 1 ? true: false,bounce2:pay_type == 1 ? true: false}"></i></span>
                        <span>{{ $t("pay.payOnline") }}</span>
                    </p>
                </div>
            </div>
            <div class="tip" v-html="reg_config.cfgFeeDesc"></div>
            <div class="clear btn-box" v-if="opFlag!='1'">
                <div @click="pre" class="btn pre left">
                    <span>{{ $t("btn.pre") }}</span>
                </div>
                <div @click="next" class="btn next right">
                    <span>{{ $t("btn.next") }}</span>
                </div>
            </div>
            <div class="clear btn-box" style="text-align:center" v-if="opFlag=='1'">
                <div @click="next" class="btn">
                    <span>{{ $t("btn.next") }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
            return {
                con_fee: {}, //报名费用
                info: {}, //第一页请求的接口数据
                pay_type: 1, //默认是线上支付
                reg_config: {}, //会议注册相关配置信息
                preActive: false, // 按钮状态 上一步
                nextActive: false, // 按钮状态 下一步
                locale: "",
                opFlag: '',
            }
        },
        computed: {
            feeId() {
                let feeId = "";
                this.con_fee.map((item, index) => {
                    this.info.reg_config.cfgDefFeeid == item.feeId ? feeId = item.feeId : ''
                });
                return feeId;
            },
        },
        mounted() {
            this.opFlag = this.$route.params.opFlag;
            this.locale = localStorage.getItem("locale");
            let sessionStore = JSON.parse(sessionStorage.getItem('info'));
            this.info = sessionStore;
            this.con_fee = sessionStore.con_fee;
            this.reg_config = sessionStore.reg_config;
            if (this.info.pay_type) {
                this.pay_type = this.info.pay_type
            } else {
                this.pay_type = 1;
            }
            //      console.log(sessionStore);
        },
        methods: {
            setPayType(key) {
                this.pay_type = key;
                this.info.pay_type = key;
                this.storeFeeid();
            },
            selectApply(feeId, feeFl) {
                if (feeFl == "0") {
                    this.$Message.warning(this.$t("info.applyError1"), 3);
                    return;
                }
                this.info.reg_config.cfgDefFeeid = feeId;
                this.storeFeeid();
            },
            storeFeeid() {
                //          console.log(this.info);
                sessionStorage.setItem('info', JSON.stringify(this.info));
            },
            pre() {
                this.preActive = true;
                this.$router.push('/sign/add/0');
            },
            next() {
                //        console.log(this.info.user_config[0].cfgCode);
                let _self = this;
                let uid = JSON.parse(localStorage.getItem('user')).uId;
                let cid = localStorage.getItem('cid') * 1;
                let regId = "";
                if (sessionStorage.getItem('info') != null && JSON.parse(sessionStorage.getItem('info')).register != null) {
                    regId = JSON.parse(sessionStorage.getItem('info')).register.regId;
                }

                if (sessionStorage.getItem('payInfo') != null && JSON.parse(sessionStorage.getItem('payInfo')).data.register != null) {
                    regId = JSON.parse(sessionStorage.getItem('payInfo')).data.register.regId;
                }

                //判断报名类型不能为空
                if (this.feeId == "") {
                    this.$Message.warning(this.$t("info.applyError2"), 3);
                    return false;
                }
                if (this.opFlag == '1') {
                    let params = {
                        regid: '',
                        uid: uid, //用户id
                        cid: cid, //会议id
                        fee_id: _self.feeId, //报名费用id
                        reg_status: '1', // 1:报名提交
                        pay_way: _self.pay_type, //付款类型  1:线上付款方式   2:线下付款方式
                        src: '2', //来源 1:WECHAT 2:WEB 3:ANDROID 4:IOS 5:后台管理
                    };
                    params.cfgid = localStorage.getItem('sourceId')||'';
                    this.postHttp('/medapp/api/template/register/add', params).then((result) => {
                        if (result.data.code == '0') {
                            this.$router.push('/order/info');
                            return true;
                        }
                    })
                } else {
                    let params = {
                        regid: regId,
                        uid: uid, //用户id
                        cid: cid, //会议id
                        fee_id: _self.feeId, //报名费用id
                        reg_status: '0', // 1:报名提交
                        pay_way: _self.pay_type, //付款类型  1:线上付款方式   2:线下付款方式
                        src: '2', //来源 1:WECHAT 2:WEB 3:ANDROID 4:IOS 5:后台管理
                    };
                    let configObj = this.info.user_config.map((item, i) => {
                        params[item.cfgCode] = item.cfgValue
                    });
                  params.cfgid = localStorage.getItem('sourceId')||'';
                    this.postHttp('/medapp/api/template/register/add', params).then((result) => {
                        if (result.data.code === '0') {
                            sessionStorage.setItem('payInfo', JSON.stringify(result));
                            this.nextActive = true;
                            //如果允许定酒店 跳到酒店预订页面
                            if (this.reg_config.cfgBookFl == '1') {
                                this.$router.push('/sign/hotel/0');
                            } else { //如果不允许预订酒店  跳到发票页面
                                this.$router.push('/sign/invoice/0');
                            }

                        } else if (result.data.code === '1230') {
                            //用户已经注册
                            this.nextActive = true;
                            this.$router.push('/sign/hotel/0');
                        }
                    })
                }
            }
        }
}
</script>
<style scoped>
.bounce {
    animation: bounce ease-in .2s;
}

.bounce2 {
    animation: bounce2 ease-in .2s;
}

@keyframes bounce {
    0% {
        transform: scale(.8, 1);
    }
    30% {
        transform: scale(1.4, 1);
    }
    70% {
        transform: scale(.8, 1);
    }
    100% {
        transform: scale(1, 1);
    }
}

@keyframes bounce2 {
    0% {
        transform: scale(.8, .8);
    }
    30% {
        transform: scale(1.4, 1.4);
    }
    70% {
        transform: scale(.8, .8);
    }
    100% {
        transform: scale(1, 1);
    }
}

.clear:after {
    display: block;
    content: '';
    clear: both;
}

.cant_select_fee {
    background-color: #999!important;
    color: #000;
}

.top-bar {
    border-bottom: 1px solid #DCDCDC;
    margin: 40px auto 20px;
}

.top-bar h2 {
    color: #000000;
    font-size: 15px;
    padding-bottom: 10px;
}

.bao-type p {
    cursor: pointer;
    line-height: 40px;
    background-color: #ffffff;
    color: #000000;
    font-size: 15px;
    margin: 20px auto;
    width: 550px;
    border-radius: 20px;
    text-align: center;
    border: 1px solid #DCDCDC;
}

.bao-type p.active {
    line-height: 40px;
    background-color: #F39800;
    color: #FFFFFF;
    font-size: 15px;
    margin: 20px auto;
    width: 550px;
    border-radius: 20px;
    text-align: center;
}

.pay-type {
    /*width: 460px;*/
    margin-left: -50px;
    margin-top: 40px;
}

.pay-type-item {
    width: 145px;
    cursor: pointer;
    color: #000000;
    font-size: 16px;
    text-align: center;
}

.left {
    float: left;
}

.right {
    float: right;
}

.pay-type-item-icon {
    font-size: 0;
    border: 1px solid #B5B5B5;
    display: inline-block;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
}

.pay-type-item-icon i {
    display: inline-block;
    padding: 5px;
    background-color: #FFFFFF;
    border-radius: 50%;
}

.pay-type-item-icon i.active {
    background-color: #F39800;
}

.tip {
    font-size: 14px;
    color: #00AAEE;
    margin-top: 44px;
    margin-left: 50px;
}

.btn {
    color: #FFFFFF;
    background-color: #33D0C2;
    line-height: 40px;
    padding: 0 70px;
    font-size: 14px;
    display: inline-block;
    cursor: pointer;
    border-radius: 30px;
    cursor: pointer;
}

.btn-box {
    width: 467px;
    margin: 50px auto 0;
}

.pay-type-box {
    width: 50%;
}

.pay-type-box p {
    margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// apply.vue?671bcd9a